module.exports = __webpack_public_path__ + "img/plan_ign.68e2bf1c.jpg";